module.exports = __webpack_public_path__ + "img/solar_card-search-outline.ea9c4373.svg";